import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote2 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>AIR-RES 2025</h1>
              <h6>The 2025 International Conference on the</h6>
              <h6>AI Revolution: Research, Ethics, and Society</h6>
              <h6>April 14-16, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>Artificial Intelligence in Publishing</b> <br/>
            Ms. Patti Davis <br/>
            Executive Editor, Computer Science Proceedings<br />
            Springer Nature<br />
            USA <br />
            <br />
            </div>
        
            <h6 className="par_header">Abstract:</h6>
            <div className="par">
            This presentation explores the transformative role of Artificial Intelligence in the publishing industry, highlighting its impact on content creation, distribution, and personalization. It covers how AI tools are automating editorial processes and enabling more personalized reading experiences for audiences. Additionally, the session examines the ethical considerations and challenges posed by AI in terms of copyright, authenticity, and bias. Attendees will gain insights into how AI is reshaping the future of publishing and what opportunities and risks lie ahead.
            </div>

            <h6 className="par_header">Speaker's Biography:</h6>
            <div className="par">
            Patti Davis has more than 20 years’ experience in publishing, starting with book acquisitions in Washington, D.C. She moved into the journals world at Emerald Group Publishing, where she managed their North American journals program. A stint at EBSCO’s Proprietary Publishing program saw her lead in innovation and product development as ground-breaking new publishing models were executed in a range of disciplines—from sustainability to business management. Patti is currently the executive editor for computer science proceedings for Springer Nature, spearheading growth of the program in the Americas. She has sat on numerous panels about publishing and received the 2024 Award of Appreciation from the Society for Scholarly Publishing.

            <br/> <br/>
            <div style={{textAlign: "center"}}>
                <img src="/static/PDavis.jpg" height="300px" alt=""/>
            </div>
            </div>          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote2;